export default __webpack_public_path__ + "static/media/dsv-ups-dom_it.e84e7b9f.svg";